import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getSignature from 'utils/print/getSignature';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getOrderLineDateOfDelivery from 'utils/print/getOrderLineDateOfDelivery';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketCappedRental = {
  ID: 14,
  Name: 'Capped Rental',
  Type: 'Delivery Ticket',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-Capped-Rental/1.js',
      Logo: {
        x: 20,
        y: 20,
        width: 75,
        height: 29,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getFacilityName(props) || getBusinessName(props),
          x: 108,
          y: 7,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 10,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 157,
          y: 27,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 157,
          y: 30.5,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 157,
          y: 34,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 157,
          y: 37.5,
          fontWeight: 'bold',
          fontSize: 8,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Description 1',
          type: 'text',
          getValue: getOrderLineHCPCSCode,
          x: 120,
          y: 74,
          width: 78,
        },
        {
          name: 'Description 2',
          type: 'text',
          x: 18,
          y: 78,
          width: 180,
        },
        {
          name: 'Description 3',
          type: 'text',
          x: 18,
          y: 81.5,
          width: 180,
        },
        {
          name: 'FOR CAPPED RENTAL ITEMS',
          type: 'checkbox',
          x: 21,
          y: 101.5,
          width: 4,
          height: 4,
        },
        {
          name: 'INEXPENSIVE PURCHASED ITEMS',
          type: 'checkbox',
          x: 21,
          y: 150.5,
          width: 4,
          height: 4,
        },
        {
          name: 'Rental Option',
          type: 'text',
          x: 84,
          y: 197,
          width: 13,
        },
        {
          name: 'Purchase Option',
          type: 'text',
          x: 138,
          y: 197,
          width: 14,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 48,
          y: 216.5,
          width: 66,
        },
        {
          name: 'Account #',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 147,
          y: 216.5,
          width: 51,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 45,
          y: 222,
          width: 65,
          height: 15,
        },
        {
          name: 'Date of Delivery',
          type: 'text',
          getValue: getSignatureDate,
          x: 147,
          y: 232.5,
          width: 51,
          normalize: normalize.date,
        },
      ],
    },
  ],
};

export default DeliveryTicketCappedRental;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-Capped-Rental.js